/**
 *
 * Asynchronously loads the component for LocationTypesPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LocationTypesPage = lazyLoad(
  () => import('./index'),
  module => module.LocationTypesPage,
);
